import DialogDefault from 'core/modules/components/dialogs/components/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import DiagramMermaid from '../DiagramMermaid/DiagramMermaid';
import './ChatMermaidModal.scss';

function ChatMermaidModal({ isOpen, mermaidCode, onClose, t, title }) {
  return (
    <DialogDefault open={isOpen} onClose={onClose} title={title || t('chatbot:Diagram')} size="xxl" hideHeader={false} separator>
      <div className="chat-mermaid-modal-container">
        {isOpen && mermaidCode && <DiagramMermaid className="chat-mermaid-modal__diagram" config={{ legacyMathML: true }} mermaidCode={mermaidCode} t={t} />}
      </div>
    </DialogDefault>
  );
}

ChatMermaidModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  mermaidCode: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ChatMermaidModal.defaultProps = {
  mermaidCode: '',
  title: '',
};

export default withTranslation(['chatbot'])(ChatMermaidModal);
